import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { HoldingsProbe } from '@bibliocommons/probes';
import Context from '@bibliocommons/context';
import AvailabilityDetailActions from 'app/actions/AvailabilityDetailActions';

const mapStateToProps = (state, ownProps) => ({
  probes: state.getIn(['entities', 'bibs', ownProps.id, 'probes'], Immutable.List())
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators(AvailabilityDetailActions, dispatch)
});

export class HoldingsProbeContainer extends React.PureComponent {
  componentDidMount() {
    this.props.getHoldingsProbes(this.props.id);
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.props.getHoldingsProbes(this.props.id);
    }
  }

  render() {
    const { probes } = this.props;

    return (
      !this.context.mobileApp && (
        <div className="cp-holdings-probes-list">
          {/* toObject is called on the probe to remain compatible with React in Rails */}
          {probes.map(probe => (
            <HoldingsProbe {...probe.toObject()} key={probe.get('siteId')} />
          ))}
        </div>
      )
    );
  }
}

HoldingsProbeContainer.propTypes = {
  probes: ImmutablePropTypes.list,
  getHoldingsProbes: PropTypes.func.isRequired,
  id: PropTypes.string
};

HoldingsProbeContainer.contextType = Context;

export default connect(mapStateToProps, mapDispatchToProps)(HoldingsProbeContainer);
